import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fz-18 font-blod color-primary" }


	
	
export default /*#__PURE__*/_defineComponent({
  __name: 'PageTitle',
  props: {
		name: {
			type: String,
			default: ""
		}
	},
  setup(__props) {

	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.name), 1))
}
}

})